// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const ThemeProvider = registerClientReference(
    function() { throw new Error("Attempted to call ThemeProvider() from the server but ThemeProvider is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/hooks/use-theme.tsx <module evaluation>",
    "ThemeProvider",
);
export const useTheme = registerClientReference(
    function() { throw new Error("Attempted to call useTheme() from the server but useTheme is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/src/hooks/use-theme.tsx <module evaluation>",
    "useTheme",
);
